// ─── SUI Wallet Connect Button ───────────────────────────────────────────
import React from 'react';
import { ConnectButton, useCurrentAccount } from '@mysten/dapp-kit';
import { useAGUBalance, formatAGU } from '../sui';

export default function WalletButton() {
  const account = useCurrentAccount();
  const { balance } = useAGUBalance();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      {account && (
        <span style={{
          background: 'rgba(0,200,120,0.12)',
          color: '#00c878',
          padding: '4px 10px',
          borderRadius: 8,
          fontSize: 13,
          fontWeight: 600,
        }}>
          {balance.toLocaleString(undefined, { maximumFractionDigits: 2 })} AGU
        </span>
      )}
      <ConnectButton />
    </div>
  );
}
